import { render, staticRenderFns } from "./TabelaTabelionato.vue?vue&type=template&id=93e18e12&scoped=true&"
import script from "./TabelaTabelionato.vue?vue&type=script&lang=js&"
export * from "./TabelaTabelionato.vue?vue&type=script&lang=js&"
import style0 from "./TabelaTabelionato.vue?vue&type=style&index=0&id=93e18e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e18e12",
  null
  
)

export default component.exports